import { c as _c } from "react-compiler-runtime";
import { useControlledState } from "@react-stately/utils";
import * as React from "react";
import { Input as AriaInput, TextField } from "react-aria-components";
import { SearchMd } from "../icons/line.js";
import * as styles from "./SearchInput.css.js";
import useI18n from "./internal/useI18n.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function SearchInput(t0) {
  const $ = _c(16);
  const {
    search,
    defaultSearch,
    onSearch,
    ariaLabel,
    searchPlaceholder
  } = t0;
  const i18n = useI18n();
  const [searchedText, setSearchedText] = useControlledState(search, defaultSearch ?? null, onSearch);
  let t1;
  if ($[0] !== ariaLabel || $[1] !== i18n) {
    t1 = i18n.format("contentSelectInput", {
      label: ariaLabel
    });
    $[0] = ariaLabel;
    $[1] = i18n;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = /*#__PURE__*/_jsx(SearchMd, {
      "aria-hidden": true,
      className: styles.popoverIcon
    });
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const t3 = searchedText ?? "";
  let t4;
  if ($[4] !== setSearchedText) {
    t4 = e => {
      setSearchedText(e.target.value);
    };
    $[4] = setSearchedText;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== i18n || $[7] !== searchPlaceholder) {
    t5 = searchPlaceholder ?? i18n.format("contentSelectInputPlaceholder");
    $[6] = i18n;
    $[7] = searchPlaceholder;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t3 || $[10] !== t4 || $[11] !== t5) {
    t6 = /*#__PURE__*/_jsx(AriaInput, {
      className: styles.popoverInput,
      value: t3,
      onChange: t4,
      placeholder: t5
    });
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t1 || $[14] !== t6) {
    t7 = /*#__PURE__*/_jsxs(TextField, {
      "aria-label": t1,
      className: styles.popoverInputGroup,
      autoFocus: true,
      children: [t2, t6]
    });
    $[13] = t1;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  return t7;
}
//# sourceMappingURL=SearchInput.js.map